import { UploadCloud01Icon } from 'primitives/icons'
import { Link } from '@repo/web-ui/components/link'

export function FeatureButton({
  label,
  href,
  hideIcon = false,
}: {
  label: string
  href: string
  hideIcon?: boolean
}) {
  return (
    <Link
      className="text-14 hover:bg-secondary-700 flex w-full cursor-pointer items-center justify-center gap-[10px] rounded bg-[#0F7B59] px-5 py-[10px] text-center font-bold uppercase text-white md:w-fit"
      href={href}
      target="_blank"
    >
      {!hideIcon ? <UploadCloud01Icon /> : null}
      {label}
    </Link>
  )
}
